import type { ThemeConfig } from "antd";
import colors from "Assets/Styles/scss/_exports.module.scss";

export const antdComponentsTheme: ThemeConfig["components"] = {
  Input: {
    activeBorderColor: colors.focus,
    hoverBorderColor: colors.focus,
    activeShadow: `0 0 0 3px ${colors.focus}`,
  },
  Select: {
    activeBorderColor: colors.focus,
    hoverBorderColor: colors.focus,
    activeOutlineColor: colors.focus,
  },
  DatePicker: {
    activeBorderColor: colors.focus,
    hoverBorderColor: colors.focus,
    activeShadow: "none",
  },
  InputNumber: {
    activeBorderColor: colors.focus,
    hoverBorderColor: colors.focus,
    activeShadow: "none",
  },
};
